<template>
	<div>
		<firstsceenimage :imgobj='banner'>
		</firstsceenimage>

	

		<Adbigwordbutton :pagetop="scrolltop" title="C2M智能定制" title2="科学定制适合脚型的鞋子" :imgurl="img1" stylemode="white"
			hidemb=true button="查看更多详情">
		</Adbigwordbutton>
		<Adbigwordbutton :pagetop="scrolltop" title="C2M数字化订货" title2="一站式鞋履供应链平台" :imgurl="img2" stylemode="white"
			hidemb=true button="查看更多详情">
		</Adbigwordbutton>
		<Adbigwordbutton :pagetop="scrolltop" title="智能制造" title2="为行业提升效能" :imgurl="img3" stylemode="blue" hidemb=true
			button="查看更多详情">
		</Adbigwordbutton>
		<Adbigwordbutton :pagetop="scrolltop" title="AI时尚趋势分析" title2="快速发现爆款" :imgurl="img4" stylemode="white"
			hidemb=true button="查看更多详情">
		</Adbigwordbutton>

		<adword style="background-color:#070E1D ; color: white;" title="C2M产业模型" slotheight="695">
			<img style="width: 100%;" src="../../static/C2M产业模型.png">

			</img>
		</adword>



	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import Adbigwordbutton from '../../components/adBigWordButton.vue'
	import adword from '../../components/adword.vue'
	import banner from '../../static/用数字化构建产业新生态.png'
	import img1 from '../../static/C2M智能定制banner1.png'
	import img2 from '../../static/数字化订货banner1.png'
	import img3 from '../../static/智能制造banner1.png'
	import img4 from '../../static/AI时尚趋势分析banner1.png'
	// import video from '../../assets/video/2.mp4'

	export default {
		name: 'Serve',
		components: {
			firstsceenimage,
			adword,
			Adbigwordbutton,
			// advideo,
		},
		data() {
			return {
				banner: banner,
				img1: img1,
				img2: img2,
				img3: img3,
				img4: img4,
				scrolltop: 0,
			}
		},
		mounted() {
			var _this = this
			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件




		},
		methods: {

			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop


			},
		},

	}
</script>

<style>
</style>
